/**
 * "Decline <company>'s request?" — asked first, because a decline is terminal
 * and the company is told. It says what declining does NOT do: nothing they
 * already see changes. (D2)
 */
import { useTranslation } from '@tonnie/locale';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  buttonVariants,
} from '@tonnie/ui';

export function DeclineShareRequestDialog({
  company,
  open,
  onOpenChange,
  onConfirm,
}: {
  company: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}) {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="share-request-decline-confirm">
        <AlertDialogHeader>
          <AlertDialogTitle>{t('invitations.request.declineTitle', { company })}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('invitations.request.declineBody', { company })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('invitations.card.declineCancel')}</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className={buttonVariants({ variant: 'destructive' })}
            data-testid="share-request-decline-confirm-action"
          >
            {t('invitations.request.declineConfirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
